import * as React from "react";
import TextField from "material-ui/TextField";

import SearchIcon from "material-ui/svg-icons/action/search";

interface WindowWithDocSearch extends Window {
	docsearch: any;
}

declare const window: WindowWithDocSearch;

interface DocSearchProps {
	style?: any;
	textFieldStyle?: any;
	onFocus(): void;
	onBlur(): void;
	isInFocus: boolean;
}

class DocSearch extends React.Component<DocSearchProps, any> {
	state = {
		value: "",
	};

	private search: any;
	private input: HTMLInputElement;

	componentDidMount() {
		// Initialize Algolia search.
		// TODO Is this expensive? Should it be deferred until a user is about to search?
		// eslint-disable-next-line no-undef
		if (window.docsearch) {
			this.search = window.docsearch({
				apiKey: "7e2d087e1eb525cbd76ce188ba4b9ad8",
				indexName: "blockv",
				inputSelector: "#search-box",
				autocompleteOptions: {
					// note: disabling for now, because this doesn't work when the bar is hidden and
					// only the icon is displayed as it is on narrower devices
					// keyboardShortcuts: ["s", "/"],
					openOnFocus: true,
					minLength: 1,
					hint: false,
				},
			});
			this.search.autocomplete.on("autocomplete:closed", e => {
				this.onBlur();
			});
		} else {
			console.warn("Search has failed to load and now is being disabled");
		}


	}

	onFocus() {
		this.props.onFocus();

		// note: doing this in a setTimeout because otherwise it doesn't work
		// i think the react re-render needs to complete first in order to focus the
		// newly instantiated search box dom element
		setTimeout(() => {
			if(this.search) {
				this.search.autocomplete.autocomplete.setVal(this.state.value);
				this.search.autocomplete.autocomplete.open();
				this.search.input.focus();
			}
		}, 1);
	}

	onBlur() {
		this.setState({value: ""});
		this.search&&this.search.autocomplete.autocomplete.setVal("");
		this.props.onBlur();
		this.input.blur();
	}

	render() {
		return (
			<div style={this.props.style}>
				<SearchIcon
					style={{
						width: 25,
						height: 25,
						cursor: "pointer",
					}}
					onClick={this.onFocus.bind(this)}
				/>

				<TextField
					id="search-box"
					className={`docsearch ${this.props.isInFocus ? "focused" : "blurred"}`}
					style={{
						marginLeft: 10,
						...(this.props.textFieldStyle || {}),
					}}
					inputStyle={{
						width: "100%",
					}}
					ref={input => (this.input = input)}
					fullWidth
					placeholder="Search..."
					value={this.state.value}
					onChange={(e, value) => {
						this.setState({ value });
					}}
					onFocus={this.onFocus.bind(this)}
					onBlur={this.onBlur.bind(this)}
				/>
			</div>
		);
	}
}

export default DocSearch;



// WEBPACK FOOTER //
// ./src/components/DocSearch.tsx